import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'

/** Any earner's statement (commissions.read); the trail starts at the runs. */
export const Route = createFileRoute('/_app/commissions/statements')({
  staticData: { crumb: 'commissionRuns' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'commissions.read'),
  component: Outlet,
})
